import { Trans } from '@lingui/react/macro';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

import type { PreferenceUpdateBody } from '../../../@types/preferences';
import { useGetRecommendationName } from '../../../modules/patientList/patientStrip/patientStripOdontogram/utils';
import { usePreferences } from '../../../react-query/usePreferences';
import { ToothProcedureNames } from '../../../react-query/useVisitSummaries';
import type { TToothProcedureNames } from '../../../react-query/useVisitSummaries';
import { mixpanelEvents, useTrackEvent } from '../../../utils/mixpanel';

interface SpotlightPreferenceProps {
  onChange: (update: PreferenceUpdateBody) => void;
}

export const SpotlightPreference = ({ onChange }: SpotlightPreferenceProps) => {
  const { data: preferences } = usePreferences();
  const { trackEvent } = useTrackEvent();
  const { getRecommendationName } = useGetRecommendationName();

  const handleChange = (
    newValue: Exclude<TToothProcedureNames, 'other'> | 'none',
  ) => {
    onChange({ spotlightProcedure: newValue });
    trackEvent(mixpanelEvents.userChangeSpotlightPreference, {
      visualization: newValue,
    });
  };

  return (
    <div className="vai-w-full">
      <p className="vai-typography-small !vai-mb-2">
        <Trans>Spotlight Visualization</Trans>
      </p>
      <Select
        value={preferences?.spotlightProcedure}
        onValueChange={handleChange}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select an option" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">
            <Trans>None</Trans>
          </SelectItem>
          <SelectItem value={ToothProcedureNames.crown}>
            {getRecommendationName('crown')}
          </SelectItem>
          <SelectItem value={ToothProcedureNames.enamelRegen}>
            {getRecommendationName('enamelRegen')}
          </SelectItem>
          <SelectItem value={ToothProcedureNames.extraction}>
            {getRecommendationName('extraction')}
          </SelectItem>
          <SelectItem value={ToothProcedureNames.filling}>
            {getRecommendationName('filling')}
          </SelectItem>
          <SelectItem value={ToothProcedureNames.implant}>
            {getRecommendationName('implant')}
          </SelectItem>
          <SelectItem value={ToothProcedureNames.rootCanal}>
            {getRecommendationName('rootCanal')}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
